module.exports = rsc;